import { observer } from 'mobx-react';
import React from 'react';

import type DocumentFolder from 'stores/DocumentFolder';

import ViewsLayout from '../ViewsLayout/ViewsLayout';
import ChildrenTable from './ChildrenTable/ChildrenTable';
import { Container } from './DocumentFolderView.styles';

export interface DocumentFolderViewProps {
  childrenTableHeaderButtons?: React.ReactNode;
  childrenTableTitle?: string;
  // Absent until the route's onEnter hook has loaded the document. Callers
  //  wiring this to store.project or store.creative are passing a value whose
  //  RootStore type still claims it is always present; store.client no longer
  //  does. Drop this note once those two are declared honestly too.
  parentDocument?: DocumentFolder;
}

function DocumentFolderView({
  childrenTableHeaderButtons,
  childrenTableTitle,
  parentDocument,
}: DocumentFolderViewProps) {
  return (
    <ViewsLayout>
      <Container>
        {parentDocument && (
          <ChildrenTable
            actionButtons={childrenTableHeaderButtons}
            parentDocument={parentDocument}
            title={childrenTableTitle}
          />
        )}
      </Container>
    </ViewsLayout>
  );
}

export default observer(DocumentFolderView);
